// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import ToastSwal from '@components/Shared/Alert/ToastSwal';

import { DndContext } from '@dnd-kit/core';
import { SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { arrayMove } from '@dnd-kit/sortable';

import Select from 'react-select';

const Step3 = ({ fields, setCheckValidationStep3, setDataStep3 }) => {
  const { t, i18n } = useTranslation();
  const [tableFields, setTableFields] = useState([]);
  const [sqlName, setsqlName] = useState('');
  const [inputType, setInputType] = useState('');
  const [aliasName, setAliasName] = useState('');
  const [label, setLabel] = useState('');

  const handleAddToTable = e => {
    e.preventDefault();
    if (sqlName && aliasName) {
      // Check if the already exists in the table array
      const Exists = tableFields?.some(item => item.Name === sqlName);
      if (Exists) {
        ToastSwal({
          icon: 'info',
          title: 'تمت إضافته مسبقاً',
          position: 'top'
        });
        return;
      }

      const newData = {
        Name: sqlName,
        Label: label,
        AliasName: aliasName,
        Sequance: tableFields?.length + 1,
        inputType: inputType
      };
      setTableFields([...tableFields, newData]);
      setsqlName('');
      setAliasName('');
      setLabel('');
    }
  };

  const handleDeleteRowClick = index => {
    const updatedTableFields = [...tableFields];
    updatedTableFields.splice(index, 1);

    updatedTableFields.forEach((item, newIndex) => {
      item.Sequance = newIndex + 1;
    });

    setTableFields(updatedTableFields);
  };

  useEffect(() => {
    setCheckValidationStep3(tableFields?.length > 0);
    setDataStep3(tableFields);
  }, [tableFields, setCheckValidationStep3]);

  const handleDragEnd = event => {
    const { active, over } = event;

    if (active?.id !== over?.id) {
      const oldIndex = tableFields.findIndex(row => row.Name === active?.id);
      const newIndex = tableFields.findIndex(row => row.Name === over?.id);
      // setTableFields((items) => arrayMove(items, oldIndex, newIndex));

      const updatedFields = arrayMove(tableFields, oldIndex, newIndex);

      // تحديث Sequance لكل صف بناءً على ترتيبه الجديد
      const reorderedFields = updatedFields.map((item, index) => ({
        ...item,
        Sequance: index + 1 // الترتيب يبدأ من 1
      }));

      setTableFields(reorderedFields);
    }
  };

  const SortableRow = ({ id, children }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
    const style = {
      transform: `translateY(${transform ? transform.y : 0}px)`,
      transition,
      cursor: 'move'
    };
    return (
      <tr ref={setNodeRef} style={style} {...listeners} {...attributes}>
        {children}
      </tr>
    );
  };

  return (
    <Fragment>
      <Form onSubmit={handleAddToTable}>
        <div className='row align-items-end'>
          <div className='col-xl-5'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('Column')}</label>
              <Select
                required
                classNamePrefix='react-select'
                isSearchable
                options={
                  fields &&
                  fields?.map(item => ({
                    value: item.name,
                    label: item.label,
                    inputType: item.inputType
                  }))
                }
                value={
                  fields
                    ?.map(item => ({
                      value: item.name,
                      label: item.label,
                      inputType: item.inputType
                    }))
                    .find(opt => opt.value === sqlName) || null
                }
                onChange={option => {
                  setsqlName(option.value);
                  setInputType(option.inputType);
                  setLabel(option.label);
                }}
                placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: base => ({ ...base, zIndex: 9999 })
                }}
              />
              {/* <Form.Select
                className='form-select'
                value={sqlName}
                onChange={e => {
                  setsqlName(e.target.value);
                  setInputType(e.target.selectedOptions[0].dataset.inputType);
                  setLabel(e.target.selectedOptions[0].dataset.label);
                }}
                required
              >
                <option>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                {fields &&
                  fields?.map((item, idx) => (
                    <option value={item.name} key={idx} data-input-type={item.inputType} data-label={item.label}>
                      {i18n.language === 'ar' ? item.label : item.label}
                    </option>
                  ))}
              </Form.Select> */}
            </div>
          </div>
          <div className='col-xl-5'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('Alias_Name')}</label>
              <Form.Control
                className='form-control'
                type='text'
                autoComplete='off'
                value={aliasName}
                onChange={e => setAliasName(e.target.value)}
                required
              />
            </div>
          </div>
          <div className='col-xl-2 text-end  '>
            <div className=' form-group mb-3 d-flex justify-content-end '>
              <button type='submit' className='btn me-1 btn-outline-theme w-100'>
                <i className='fa fa-plus-circle fa-fw me-1'></i>
                {t('Add')}
              </button>
            </div>
          </div>
        </div>
      </Form>

      {tableFields?.length > 0 ? (
        <DndContext onDragEnd={handleDragEnd}>
          <SortableContext items={tableFields.map(row => row.Name)} strategy={verticalListSortingStrategy}>
            <table className='table table-hover'>
              <thead className='bg-theme bg-opacity-60'>
                <tr>
                  <th style={{ width: '10%' }}></th>
                  <th style={{ width: '10%' }}>{t('Order')}</th>
                  <th style={{ width: '35%' }}>{t('Column')}</th>
                  <th style={{ width: '35%' }}>{t('Alias_Name')}</th>
                  <th style={{ width: '10%' }} className='text-end'></th>
                </tr>
              </thead>
              <tbody>
                {tableFields.map((row, index) => (
                  <SortableRow key={row.Name} id={row.Name}>
                    <td className='align-middle'>
                      {' '}
                      <a
                        href='/#'
                        title='مقبض السحب'
                        style={{
                          textDecoration: 'none',
                          cursor: 'grab',
                          pointerEvents: 'none'
                        }}
                      >
                        ⁞⁞
                      </a>{' '}
                    </td>
                    <td className='align-middle'>{row.Sequance}</td>
                    <td className='align-middle'>{row.Label}</td>
                    <td className='align-middle'>{row.AliasName}</td>
                    <td className='align-middle text-end'>
                      <button
                        type='button'
                        className='btn btn-sm btn-outline-danger me-1'
                        onClick={() => handleDeleteRowClick(index)}
                        onPointerDown={e => e.stopPropagation()} // منع السحب عند النقر
                      >
                        <i className='fas fa-trash-alt fa-lg '></i>
                        {/* {t('Delete')} */}
                      </button>
                    </td>
                  </SortableRow>
                ))}
              </tbody>
            </table>
          </SortableContext>
        </DndContext>
      ) : (
        <div className='border border-theme text-center bg-inverse bg-opacity-10 rounded-2 p-3 fw-bold'>
          {i18n.language === 'ar' ? 'لا يوجد أعمدة محددة للتقرير.' : 'No selected columns for report.'}
          {/* {t('الرجاء اختيار الأعمدة المراد عرضها في التقرير.')} */}
        </div>
      )}
    </Fragment>
  );
};

// const Step3 = ({ fields, setCheckValidationStep3, setDataStep3 }) => {
// const { t, i18n } = useTranslation();

// const [tableFields, setTableFields] = useState([]);
// const [sqlName, setsqlName] = useState('');
// const [inputType, setInputType] = useState('');
// const [aliasName, setAliasName] = useState('');
// const [label, setLabel] = useState('');

// const handleAddToTable = (e) => {
//   e.preventDefault();
//   if (sqlName && aliasName) {
//     // Check if the already exists in the table array
//     const Exists = tableFields?.some((item) => item.Name === sqlName);
//     if (Exists) {
//       ToastSwal({
//         icon: 'info',
//         title: 'تمت إضافته مسبقاً',
//         position: 'top',
//       });
//       return;
//     }

//     const newData = {
//       Name: sqlName,
//       Label: label,
//       AliasName: aliasName,
//       Sequance: tableFields?.length + 1,
//       inputType: inputType,
//     };
//     setTableFields([...tableFields, newData]);
//     setsqlName('');
//     setAliasName('');
//     setLabel('');
//   }
// };

// const handleDeleteRowClick = (index) => {
//   const updatedTableFields = [...tableFields];
//   updatedTableFields.splice(index, 1);

//   updatedTableFields.forEach((item, newIndex) => {
//     item.Sequance = newIndex + 1;
//   });

//   setTableFields(updatedTableFields);
// };

// // const handleSequanceChange = (e, index) => {
// //   const updatedTableFields = [...tableFields];
// //   updatedTableFields[index].Sequance = e.target.value;
// //   setTableFields(updatedTableFields);
// // };

// const handleSequanceChange = (e, index) => {
//   const newSequance = e.target.value;

//   // التحقق من أن القيمة ليست سالباً
//   if (newSequance < 0) {
//     ToastSwal({
//       icon: 'error',
//       title: 'الترتيب لا يمكن أن يكون سالباً',
//       position: 'bottom-left',
//     });
//     return; // عدم تحديث القيمة إذا كانت سلبية
//   }

//   // التحقق من عدم تكرار الترتيب
//   // const isDuplicate = tableFields.some((item, idx) => idx !== index && item.Sequance === newSequance);
//   // if (isDuplicate) {
//   //   ToastSwal({
//   //     icon: 'error',
//   //     title: 'الترتيب هذا مكرر',
//   //     position: 'top',
//   //   });
//   //   return; // عدم تحديث القيمة إذا كانت مكررة
//   // }

//   // تحديث الترتيب في الجدول إذا كانت القيمة صحيحة
//   const updatedTableFields = [...tableFields];
//   updatedTableFields[index].Sequance = newSequance;
//   setTableFields(updatedTableFields);
// };

// //_______________________ Stard Validation Table  ______________________________________
// useEffect(() => {
//   setCheckValidationStep3(tableFields?.length > 0);
//   setDataStep3(tableFields);
// }, [tableFields, setCheckValidationStep3]);
// //_______________________ End Validation Table  ______________________________________

//   return (
//     <Fragment>
//       <Form onSubmit={handleAddToTable}>
//         <div className="row align-items-end">
//           <div className="col-xl-5">
//             <div className="form-group mb-3">
//               <label className="form-label">{t('Column')}</label>
//               <Form.Select
//                 className="form-select"
//                 value={sqlName}
//                 onChange={(e) => {
//                   setsqlName(e.target.value);
//                   setInputType(e.target.selectedOptions[0].dataset.inputType);
//                   setLabel(e.target.selectedOptions[0].dataset.label);
//                 }}
//                 required>
//                 <option>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                 {fields &&
//                   fields?.map((item, idx) => (
//                     <option
//                       value={item.name}
//                       key={idx}
//                       data-input-type={item.inputType}
//                       data-label={item.label}>
//                       {i18n.language === 'ar' ? item.label : item.label}
//                     </option>
//                   ))}
//               </Form.Select>
//             </div>
//           </div>
//           <div className="col-xl-5">
//             <div className="form-group mb-3">
//               <label className="form-label">{t('Alias_Name')}</label>
//               <Form.Control
//                 className="form-control"
//                 type="text"
//                 autoComplete="off"
//                 value={aliasName}
//                 onChange={(e) => setAliasName(e.target.value)}
//                 required
//               />
//             </div>
//           </div>
//           <div className="col-xl-2 text-end  ">
//             <div className=" form-group mb-3 d-flex justify-content-end ">
//               <button type="submit" className="btn me-1 btn-outline-theme w-100">
//                 <i className="fa fa-plus-circle fa-fw me-1"></i>
//                 {t('Add')}
//               </button>
//             </div>
//           </div>
//         </div>
//       </Form>

//       {tableFields?.length > 0 ? (
//         <div className="row">
//           <div className="col-xl-12 m-auto">
//             <div className="table-responsive rounded-2 text-center ">
//               <table className="table table-hover">
//                 <thead className="bg-theme bg-opacity-60">
//                   <tr>
//                     <th style={{ width: '10%' }}></th>
//                     <th style={{ width: '35%' }}>{t('Column')}</th>
//                     <th style={{ width: '35%' }}>{t('Alias_Name')}</th>
//                     <th style={{ width: '10%' }}>الترتيب</th>
//                     <th style={{ width: '10%' }} className="text-end"></th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {tableFields
//                     ?.sort((a, b) => a.Sequance - b.Sequance)
//                     ?.map((item, index) => (
//                       // <tr key={index} title="إسحب لتغيير الترتيب">
//                       <tr key={index}>
//                         <td className="align-middle">
//                           {' '}
//                           <a
//                             href="/#"
//                             title="مقبض السحب"
//                             style={{
//                               textDecoration: 'none',
//                               cursor: 'grab',
//                               pointerEvents: 'none',
//                             }}>
//                             ⁞⁞
//                           </a>{' '}
//                         </td>
//                         <td className="align-middle">{item.Label}</td>
//                         <td className="align-middle">{item.AliasName}</td>
//                         <td className="align-middle">
//                           <Form.Control
//                             className="form-control form-control-sm text-center text-theme fs-5"
//                             type="number"
//                             value={item.Sequance}
//                             onChange={(e) => handleSequanceChange(e, index)}
//                           />
//                         </td>
//                         <td className="align-middle text-end">
//                           <Link
//                             style={{ color: 'red' }}
//                             onClick={() => handleDeleteRowClick(index)}>
//                             <i className="fas fa-lg fa-fw me-3 fa-trash-alt"></i>
//                           </Link>
//                         </td>
//                       </tr>
//                     ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       ) : (
//         <div className="border border-theme text-center bg-inverse bg-opacity-10 rounded-2 p-3 fw-bold">
//           {t('الرجاء اختيار الأعمدة المراد عرضها في التقرير.')}
//         </div>
//       )}
//     </Fragment>
//   );
// };

export default memo(Step3);
